// extracted by mini-css-extract-plugin
module.exports = {"tabGroup":"_31jaOINV1Lo03jsoJjLW_t","badge":"w33soCGYXUSsihu-ZymGs"};